var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"w-full text-left bg-white app-table",class:{ 'app-table-plain': this.theme === 'plain' }},[_c('thead',{class:_vm.theadStyles},[_vm._t("thead")],2),_c('tbody',[_vm._t("tbody")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }